/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SpringPages.css';

export default function AboutPage() {
  const navigate = useNavigate();

  return (
    <div className="spring-page" data-testid="about-page">
      <div className="spring-page-inner" style={{ paddingTop: 32 }}>
        <span className="spring-label">About</span>
        <h1 className="spring-headline">what SPRING actually is.</h1>

        <p className="spring-body-lg">Lost your job? About to walk away from one? Either way, the question's the same: what now?</p>
        <p className="spring-body-muted">An online guided journey. In stages, taken one at a time, at your pace, from wherever you are.</p>

        {/* Three Forest cards */}
        <div className="spring-card-row">
          <div className="spring-forest-card">
            <span className="spring-forest-card-num">01</span>
            <h3>the structure</h3>
            <p>The platform walks you through every step. What to do, in what order, and why it matters.</p>
          </div>
          <div className="spring-forest-card">
            <span className="spring-forest-card-num">02</span>
            <h3>the people</h3>
            <p>Real human mentors who have done hard things themselves, and a community walking the same road at the same time as you.</p>
          </div>
          <div className="spring-forest-card">
            <span className="spring-forest-card-num">03</span>
            <h3>the AI coach</h3>
            <p>Available around the clock, because the wobble doesn't keep office hours and sometimes you need someone at 11pm.</p>
          </div>
        </div>

        <p className="spring-body-italic">Structure you can follow at midnight in your trackies. Real people to reach for when a decision feels too big to make alone.</p>

        <p className="spring-body-bold">And there's no single right path here. There are three. The assessment helps you find yours.</p>

        <div className="spring-btn-row">
          <button className="spring-btn-petal" onClick={() => navigate('/assessment')} data-testid="about-start-btn">
            Start the assessment
          </button>
        </div>
      </div>
    </div>
  );
}
